import { Link } from "react-router-dom";
import { connect } from "react-redux";

var BookCover = require("components/reading/books/BookCover");
var Spinner = require("components/utility/Spinner");
var EmptyStateContainer = require("components/utility/EmptyStateContainer");

var ReactTooltip = require("react-tooltip");
var ParticipatingStudentsDisplay = require("components/reading/ParticipatingStudentsDisplay");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("reading/shelves/book_grid.scss");

@connect(
	(state, props) => {
		// This isn't particularly elegant
		var studentNameLookup = {}
		_.each(RosterSelectors.students({ state }), (student) => {
			studentNameLookup[student.id] = student.display_name;
		})
		return { studentNameLookup };
	},

	(dispatch, props) => ({})
)
class BookGrid extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			visibleRowCount: 4
		};
	}

	selectBook(text_id) {
		if (this.props.onBookSelect) {
			this.props.onBookSelect(text_id);
		}
	}

	visibleBooks() {
		var sortedBooks = _.sortBy(this.props.books, (book) => {
			return $wr.padleft(book.user_ids.length, 4) + "-" + book.last_active;
		}).reverse();


		return _.first(sortedBooks, this.state.visibleRowCount * BOOKS_PER_ROW);
	}

	render() {
		const MAX_DISPLAY_STUDENT_COUNT = 3;

		if (this.props.books.length > 0 || this.props.loading) {

			var gridContent = _.map(this.visibleBooks(), (book, index) => {
				var teachersPick = false
				if (book.teachers_pick) {
					teachersPick = true
				}
				var userDraftCounts = book.quiz_draft_counts || {};
				if (this.props.showStudentIDs) {
					var activeStudentIDs = _.intersection(
						this.props.showStudentIDs,
						book.user_ids
					)

					var studentsDisplayContainer = (
						<div className="studentsDisplayContainer">
							<ParticipatingStudentsDisplay studentIDs={ activeStudentIDs }
								maxDisplayStudentCount={ MAX_DISPLAY_STUDENT_COUNT } />
						</div>
					)
				}
				

				return (
					<div className="bookContainer" key={ book.text_id } onClick={ this.selectBook.bind(this, book.text_id) }>
						<BookCover book={ book } coverWidth={ 105 }
							showTitle={ false } showAuthor={ false }
							displayQuizTaken={ this.props.showQuizIcons }
							quizTaken={ book.quiz_counts != undefined }
							quizDraft={_.size(userDraftCounts) > 0}
							teachersPick={ teachersPick }
						/>
						{ studentsDisplayContainer }
					</div>
				);
			});
		}

		if (this.props.loading) {
			var spinner = (<Spinner scale={ 2.0 } placeholder={ true } />);
		}

		return (
			<div className="bookGrid" ref="wrapper">
				<div>
					{ gridContent }
				</div>
				{ spinner }
			</div>
		)
	}


	checkScroll() {
		if (!this.props.loading) {
			var $wrapper = $(this.refs.wrapper);
			var threshold = 300;
			var lim = $wrapper.offset().top + $wrapper.height();
			var loc = $(window).scrollTop() + $(window).height();
			if (loc + threshold > lim) {
				if (this.state.visibleRowCount * BOOKS_PER_ROW < this.props.books.length) {
					this.setState({ visibleRowCount: this.state.visibleRowCount + 4 });
				}
			}			
		}
	}

	componentDidMount() {
		$(window).scroll(this.checkScroll);
	}

	componentWillUnmount() {
		$(window).off("scroll", this.checkScroll);
	}
}

const BOOKS_PER_ROW = 6;

BookGrid.WrappedComponent.propTypes = StrictPropTypes({
	books: PropTypes.array.isRequired,
	onBookSelect: PropTypes.func,
	showQuizIcons: PropTypes.bool,
	showStudentIDs: PropTypes.array,

	// Show a spinner and block onEnd notices if this is true
	loading: PropTypes.bool,

	studentNameLookup: PropTypes.object
});

module.exports = BookGrid;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/BookGrid.js